import axios from "axios";
import {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import exportFromJSON from "export-from-json";
import { Col, Container, Row } from "react-bootstrap";
import { useParams, useHistory, useLocation } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import { GlobalContext } from "../../../context/GlobalState";
import "./StudentSubmissionReport.css";
import { ReportHeader } from "./Component/ReportHeader";
import { Question } from "./Component/Questions/Question";
import { useAlert } from "react-alert";

import "./EvaluateReport.css";
import "./Media.css";
import SummaryEvaluationBox from "./Component/SummaryEvaluation";

//Working on OT marking
const StudentSubmissionReport = () => {
  const history = useHistory();
  const alert = useAlert();
  const { userDetails } = useContext(GlobalContext);
  const params = useParams();
  const location = useLocation();
  const [submission, setSubmission] = useState(null);
  const isSmallScreen = useMediaQuery({
    query: "(max-width:450px)",
  });

  const query = useMemo(() => {
    const searchParams = new URLSearchParams(location.search);
    return {
      testName:searchParams.get("testName")
    }
  },[location]);

  const fetchSubmission = async () => {
    const authToken = localStorage.getItem("authToken");
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_ORIGIN}/api/v1/grades/${userDetails.grade}/sections/${userDetails.section}/assignTests/${params.testId}/report`,
        {
          headers: {
            token: authToken,
          },
        },
      );
      if (response.data.status === "success") {
        const submission = response.data.data.submission;
        setSubmission(submission);
      }
      return;
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchSubmission();
  }, []);

  return (
    <>
      <br />
      <ReportHeader
        isSmallScreen={isSmallScreen}
        heading={query.testName || ""}
      />
      <Container className="mx-auto container">
        {submission ? (
          <SummaryEvaluationBox
            totalScore={submission?.totalMarks || 0}
            studentScore={submission?.totalScore || 0}
            feedback={submission?.feedback || ""}
          />
        ) : null}
        <br/>
        {(submission?.questionSet?.questions || []).map((qt, index) => {
          const attempt = submission.answers.find(
            (ans) => ans?.questionId === qt.questionId?._id,
          );
          return (
            <Question
              index={index + 1}
              question={qt.questionId}
              attempt={attempt}
              mark={qt.marks}
            />
          );
        })}
        
        <br />
        <br />
      </Container>
    </>
  );
};

export default StudentSubmissionReport;
